<script lang="ts">
  interface Props {
    currentStep: number;
    isAuthenticated: boolean;
    onStepClick: (step: number) => void;
  }

  let { currentStep, isAuthenticated, onStepClick }: Props = $props();

  const steps = [
    { number: 1, label: 'Business Details' },
    { number: 2, label: 'Choose Plan' },
    { number: 3, label: 'Payment' },
  ];
</script>

<div class="step-indicator">
  {#each steps as step, i}
    {#if i > 0}
      <div class="step-connector" class:completed={currentStep > step.number - 1}></div>
    {/if}
    <button
      type="button"
      class="step"
      class:active={currentStep === step.number}
      class:completed={currentStep > step.number}
      class:clickable={step.number < 3 || isAuthenticated}
      class:disabled={step.number === 3 && !isAuthenticated}
      onclick={() => onStepClick(step.number)}
      disabled={step.number === 3 && !isAuthenticated}
    >
      <span class="step-number">{step.number}</span>
      <span class="step-label">{step.label}</span>
    </button>
  {/each}
</div>

<style>
  .step-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    margin-bottom: 2rem;
  }

  .step {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.2);
    transition: all 0.25s ease;
    border: none;
    font-family: inherit;
  }

  .step.clickable {
    cursor: pointer;
  }

  .step.clickable:hover:not(.active) {
    background: rgba(255, 255, 255, 0.35);
    transform: translateY(-1px);
  }

  .step.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .step.active {
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .step.active .step-number,
  .step.active .step-label {
    color: #4A7DFF;
  }

  .step.completed {
    background: rgba(255, 255, 255, 0.4);
  }

  .step.completed .step-number {
    color: white;
    background: #10b981;
  }

  .step-number {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 0.85rem;
    color: white;
    transition: all 0.25s ease;
  }

  .step.active .step-number {
    background: #4A7DFF;
    color: white;
  }

  .step-label {
    font-weight: 600;
    color: white;
    font-size: 0.9rem;
    transition: color 0.25s ease;
  }

  .step-connector {
    width: 3rem;
    height: 2px;
    background: rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
  }

  .step-connector.completed {
    background: white;
  }

  @media (max-width: 640px) {
    .step-label {
      display: none;
    }
  }
</style>
